"use strict";

var _classCallCheck = require("/home/paul/Projects/ResoluteWeb/resoluteweb/src/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/paul/Projects/ResoluteWeb/resoluteweb/src/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorUtils = void 0;

var Utils_1 = require("./Utils");

var Constants_1 = require("./Constants");

var NumberUtils_1 = require("./NumberUtils");

function hue2rgb(p, q, t) {
  var tCalc = t;

  if (tCalc < 0) {
    tCalc += 1;
  }

  if (tCalc > 1) {
    tCalc -= 1;
  }

  if (tCalc < 1 / 6) {
    return p + (q - p) * 6 * tCalc;
  }

  if (tCalc < 1 / 2) {
    return q;
  }

  if (tCalc < 2 / 3) {
    return p + (q - p) * (2 / 3 - tCalc) * 6;
  }

  return p;
}

function stringToRgba(input) {
  if (input.startsWith("rgb")) {
    var regex = /rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*([\d.]+)\s*)?\)/i;
    var result = regex.exec(input);
    return result ? {
      a: result.length > 4 ? parseFloat(result[5]) : 1,
      b: parseInt(result[3], 10),
      g: parseInt(result[2], 10),
      r: parseInt(result[1], 10)
    } : undefined;
  } else if (input.startsWith("hsl")) {
    var _regex = /hsla?\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([\d.]+)\s*)?\)/i;

    var _result = _regex.exec(input);

    return _result ? ColorUtils.hslaToRgba({
      a: _result.length > 4 ? parseFloat(_result[5]) : 1,
      h: parseInt(_result[1], 10),
      l: parseInt(_result[3], 10),
      s: parseInt(_result[2], 10)
    }) : undefined;
  } else if (input.startsWith("hsv")) {
    var _regex2 = /hsva?\(\s*(\d+)°\s*,\s*(\d+)%\s*,\s*(\d+)%\s*(,\s*([\d.]+)\s*)?\)/i;

    var _result2 = _regex2.exec(input);

    return _result2 ? ColorUtils.hsvaToRgba({
      a: _result2.length > 4 ? parseFloat(_result2[5]) : 1,
      h: parseInt(_result2[1], 10),
      s: parseInt(_result2[2], 10),
      v: parseInt(_result2[3], 10)
    }) : undefined;
  } else {
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i;
    var hexFixed = input.replace(shorthandRegex, function (_m, r, g, b, a) {
      return r + r + g + g + b + b + (a !== undefined ? a + a : "");
    });
    var _regex3 = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i;

    var _result3 = _regex3.exec(hexFixed);

    return _result3 ? {
      a: _result3[4] !== undefined ? parseInt(_result3[4], 16) / 0xff : 1,
      b: parseInt(_result3[3], 16),
      g: parseInt(_result3[2], 16),
      r: parseInt(_result3[1], 16)
    } : undefined;
  }
}

var ColorUtils = /*#__PURE__*/function () {
  function ColorUtils() {
    _classCallCheck(this, ColorUtils);
  }

  _createClass(ColorUtils, null, [{
    key: "colorToRgb",
    value: function colorToRgb(input, index) {
      var useIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var _a, _b, _c;

      if (input === undefined) {
        return;
      }

      var color = typeof input === "string" ? {
        value: input
      } : input;
      var res;

      if (typeof color.value === "string") {
        if (color.value === Constants_1.Constants.randomColorValue) {
          res = ColorUtils.getRandomRgbColor();
        } else {
          res = ColorUtils.stringToRgb(color.value);
        }
      } else {
        if (color.value instanceof Array) {
          var colorSelected = Utils_1.Utils.itemFromArray(color.value, index, useIndex);
          res = ColorUtils.colorToRgb({
            value: colorSelected
          });
        } else {
          var colorValue = color.value;
          var rgbColor = (_a = colorValue.rgb) !== null && _a !== void 0 ? _a : color.value;

          if (rgbColor.r !== undefined) {
            res = rgbColor;
          } else {
            var hslColor = (_b = colorValue.hsl) !== null && _b !== void 0 ? _b : color.value;

            if (hslColor.h !== undefined && hslColor.l !== undefined) {
              res = ColorUtils.hslToRgb(hslColor);
            } else {
              var hsvColor = (_c = colorValue.hsv) !== null && _c !== void 0 ? _c : color.value;

              if (hsvColor.h !== undefined && hsvColor.v !== undefined) {
                res = ColorUtils.hsvToRgb(hsvColor);
              }
            }
          }
        }
      }

      return res;
    }
  }, {
    key: "colorToHsl",
    value: function colorToHsl(color, index) {
      var useIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var rgb = ColorUtils.colorToRgb(color, index, useIndex);
      return rgb !== undefined ? ColorUtils.rgbToHsl(rgb) : undefined;
    }
  }, {
    key: "rgbToHsl",
    value: function rgbToHsl(color) {
      var r1 = color.r / 255;
      var g1 = color.g / 255;
      var b1 = color.b / 255;
      var max = Math.max(r1, g1, b1);
      var min = Math.min(r1, g1, b1);
      var res = {
        h: 0,
        l: (max + min) / 2,
        s: 0
      };

      if (max != min) {
        res.s = res.l < 0.5 ? (max - min) / (max + min) : (max - min) / (2.0 - max - min);
        res.h = r1 === max ? (g1 - b1) / (max - min) : res.h = g1 === max ? 2.0 + (b1 - r1) / (max - min) : 4.0 + (r1 - g1) / (max - min);
      }

      res.l *= 100;
      res.s *= 100;
      res.h *= 60;

      if (res.h < 0) {
        res.h += 360;
      }

      return res;
    }
  }, {
    key: "stringToAlpha",
    value: function stringToAlpha(input) {
      var _a;

      return (_a = stringToRgba(input)) === null || _a === void 0 ? void 0 : _a.a;
    }
  }, {
    key: "stringToRgb",
    value: function stringToRgb(input) {
      return stringToRgba(input);
    }
  }, {
    key: "hslToRgb",
    value: function hslToRgb(hsl) {
      var result = {
        b: 0,
        g: 0,
        r: 0
      };
      var hslPercent = {
        h: hsl.h / 360,
        l: hsl.l / 100,
        s: hsl.s / 100
      };

      if (hslPercent.s === 0) {
        result.b = hslPercent.l;
        result.g = hslPercent.l;
        result.r = hslPercent.l;
      } else {
        var q = hslPercent.l < 0.5 ? hslPercent.l * (1 + hslPercent.s) : hslPercent.l + hslPercent.s - hslPercent.l * hslPercent.s;
        var p = 2 * hslPercent.l - q;
        result.r = hue2rgb(p, q, hslPercent.h + 1 / 3);
        result.g = hue2rgb(p, q, hslPercent.h);
        result.b = hue2rgb(p, q, hslPercent.h - 1 / 3);
      }

      result.r = Math.floor(result.r * 255);
      result.g = Math.floor(result.g * 255);
      result.b = Math.floor(result.b * 255);
      return result;
    }
  }, {
    key: "hslaToRgba",
    value: function hslaToRgba(hsla) {
      var rgbResult = ColorUtils.hslToRgb(hsla);
      return {
        a: hsla.a,
        b: rgbResult.b,
        g: rgbResult.g,
        r: rgbResult.r
      };
    }
  }, {
    key: "hslToHsv",
    value: function hslToHsv(hsl) {
      var l = hsl.l / 100,
          sl = hsl.s / 100;
      var v = l + sl * Math.min(l, 1 - l),
          sv = !v ? 0 : 2 * (1 - l / v);
      return {
        h: hsl.h,
        s: sv * 100,
        v: v * 100
      };
    }
  }, {
    key: "hslaToHsva",
    value: function hslaToHsva(hsla) {
      var hsvResult = ColorUtils.hslToHsv(hsla);
      return {
        a: hsla.a,
        h: hsvResult.h,
        s: hsvResult.s,
        v: hsvResult.v
      };
    }
  }, {
    key: "hsvToHsl",
    value: function hsvToHsl(hsv) {
      var v = hsv.v / 100,
          sv = hsv.s / 100;
      var l = v * (1 - sv / 2),
          sl = l === 0 || l === 1 ? 0 : (v - l) / Math.min(l, 1 - l);
      return {
        h: hsv.h,
        l: l * 100,
        s: sl * 100
      };
    }
  }, {
    key: "hsvaToHsla",
    value: function hsvaToHsla(hsva) {
      var hslResult = ColorUtils.hsvToHsl(hsva);
      return {
        a: hsva.a,
        h: hslResult.h,
        l: hslResult.l,
        s: hslResult.s
      };
    }
  }, {
    key: "hsvToRgb",
    value: function hsvToRgb(hsv) {
      var result = {
        b: 0,
        g: 0,
        r: 0
      };
      var hsvPercent = {
        h: hsv.h / 60,
        s: hsv.s / 100,
        v: hsv.v / 100
      };
      var c = hsvPercent.v * hsvPercent.s,
          x = c * (1 - Math.abs(hsvPercent.h % 2 - 1));
      var tempRgb;

      if (hsvPercent.h >= 0 && hsvPercent.h <= 1) {
        tempRgb = {
          r: c,
          g: x,
          b: 0
        };
      } else if (hsvPercent.h > 1 && hsvPercent.h <= 2) {
        tempRgb = {
          r: x,
          g: c,
          b: 0
        };
      } else if (hsvPercent.h > 2 && hsvPercent.h <= 3) {
        tempRgb = {
          r: 0,
          g: c,
          b: x
        };
      } else if (hsvPercent.h > 3 && hsvPercent.h <= 4) {
        tempRgb = {
          r: 0,
          g: x,
          b: c
        };
      } else if (hsvPercent.h > 4 && hsvPercent.h <= 5) {
        tempRgb = {
          r: x,
          g: 0,
          b: c
        };
      } else if (hsvPercent.h > 5 && hsvPercent.h <= 6) {
        tempRgb = {
          r: c,
          g: 0,
          b: x
        };
      }

      if (tempRgb) {
        var m = hsvPercent.v - c;
        result.r = Math.floor((tempRgb.r + m) * 255);
        result.g = Math.floor((tempRgb.g + m) * 255);
        result.b = Math.floor((tempRgb.b + m) * 255);
      }

      return result;
    }
  }, {
    key: "hsvaToRgba",
    value: function hsvaToRgba(hsva) {
      var rgbResult = ColorUtils.hsvToRgb(hsva);
      return {
        a: hsva.a,
        b: rgbResult.b,
        g: rgbResult.g,
        r: rgbResult.r
      };
    }
  }, {
    key: "rgbToHsv",
    value: function rgbToHsv(rgb) {
      var rgbPercent = {
        r: rgb.r / 255,
        g: rgb.g / 255,
        b: rgb.b / 255
      },
          xMax = Math.max(rgbPercent.r, rgbPercent.g, rgbPercent.b),
          xMin = Math.min(rgbPercent.r, rgbPercent.g, rgbPercent.b),
          v = xMax,
          c = xMax - xMin;
      var h = 0;

      if (v === rgbPercent.r) {
        h = 60 * ((rgbPercent.g - rgbPercent.b) / c);
      } else if (v === rgbPercent.g) {
        h = 60 * (2 + (rgbPercent.b - rgbPercent.r) / c);
      } else if (v === rgbPercent.b) {
        h = 60 * (4 + (rgbPercent.r - rgbPercent.g) / c);
      }

      var s = !v ? 0 : c / v;
      return {
        h: h,
        s: s * 100,
        v: v * 100
      };
    }
  }, {
    key: "rgbaToHsva",
    value: function rgbaToHsva(rgba) {
      var hsvResult = ColorUtils.rgbToHsv(rgba);
      return {
        a: rgba.a,
        h: hsvResult.h,
        s: hsvResult.s,
        v: hsvResult.v
      };
    }
  }, {
    key: "getRandomRgbColor",
    value: function getRandomRgbColor(min) {
      var fixedMin = min !== null && min !== void 0 ? min : 0;
      return {
        b: Math.floor(NumberUtils_1.NumberUtils.randomInRange(fixedMin, 256)),
        g: Math.floor(NumberUtils_1.NumberUtils.randomInRange(fixedMin, 256)),
        r: Math.floor(NumberUtils_1.NumberUtils.randomInRange(fixedMin, 256))
      };
    }
  }, {
    key: "getStyleFromRgb",
    value: function getStyleFromRgb(color, opacity) {
      return "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(opacity !== null && opacity !== void 0 ? opacity : 1, ")");
    }
  }, {
    key: "getStyleFromHsl",
    value: function getStyleFromHsl(color, opacity) {
      return "hsla(".concat(color.h, ", ").concat(color.s, "%, ").concat(color.l, "%, ").concat(opacity !== null && opacity !== void 0 ? opacity : 1, ")");
    }
  }, {
    key: "getStyleFromHsv",
    value: function getStyleFromHsv(color, opacity) {
      return ColorUtils.getStyleFromHsl(ColorUtils.hsvToHsl(color), opacity);
    }
  }, {
    key: "mix",
    value: function mix(color1, color2, size1, size2) {
      var rgb1 = color1;
      var rgb2 = color2;

      if (rgb1.r === undefined) {
        rgb1 = ColorUtils.hslToRgb(color1);
      }

      if (rgb2.r === undefined) {
        rgb2 = ColorUtils.hslToRgb(color2);
      }

      return {
        b: NumberUtils_1.NumberUtils.mix(rgb1.b, rgb2.b, size1, size2),
        g: NumberUtils_1.NumberUtils.mix(rgb1.g, rgb2.g, size1, size2),
        r: NumberUtils_1.NumberUtils.mix(rgb1.r, rgb2.r, size1, size2)
      };
    }
  }, {
    key: "replaceColorSvg",
    value: function replaceColorSvg(image, color, opacity) {
      if (!image.svgData) {
        return "";
      }

      var svgXml = image.svgData;
      var rgbHex = /#([0-9A-F]{3,6})/gi;
      return svgXml.replace(rgbHex, function () {
        return ColorUtils.getStyleFromHsl(color, opacity);
      });
    }
  }, {
    key: "getLinkColor",
    value: function getLinkColor(p1, p2, linkColor) {
      var _a, _b;

      if (linkColor === Constants_1.Constants.randomColorValue) {
        return ColorUtils.getRandomRgbColor();
      } else if (linkColor === "mid") {
        var sourceColor = (_a = p1.getFillColor()) !== null && _a !== void 0 ? _a : p1.getStrokeColor();
        var destColor = (_b = p2 === null || p2 === void 0 ? void 0 : p2.getFillColor()) !== null && _b !== void 0 ? _b : p2 === null || p2 === void 0 ? void 0 : p2.getStrokeColor();

        if (sourceColor && destColor && p2) {
          return ColorUtils.mix(sourceColor, destColor, p1.getRadius(), p2.getRadius());
        } else {
          var hslColor = sourceColor !== null && sourceColor !== void 0 ? sourceColor : destColor;

          if (hslColor) {
            return ColorUtils.hslToRgb(hslColor);
          }
        }
      } else {
        return linkColor;
      }
    }
  }, {
    key: "getLinkRandomColor",
    value: function getLinkRandomColor(optColor, blink, consent) {
      var color = typeof optColor === "string" ? optColor : optColor.value;

      if (color === Constants_1.Constants.randomColorValue) {
        if (consent) {
          return ColorUtils.colorToRgb({
            value: color
          });
        } else if (blink) {
          return Constants_1.Constants.randomColorValue;
        } else {
          return Constants_1.Constants.midColorValue;
        }
      } else {
        return ColorUtils.colorToRgb({
          value: color
        });
      }
    }
  }]);

  return ColorUtils;
}();

exports.ColorUtils = ColorUtils;